if (!window.GUMODEProductCustomTabsLoaded) {
  window.GUMODEProductCustomTabsLoaded = true;

  (() => {
  const sectionSelector = '[data-product-custom-tabs]';

  const activateTab = (container, targetTab) => {
    const tabs = Array.from(container.querySelectorAll('[data-detail-tab]'));
    const panels = Array.from(container.querySelectorAll('[data-detail-content]'));
    const targetId = targetTab?.getAttribute('data-detail-tab');

    if (!targetId) return;

    tabs.forEach((tab) => {
      const isActive = tab === targetTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive.toString());
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-detail-content') === targetId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  };

  const onTabKeydown = (container, event) => {
    const tabs = Array.from(container.querySelectorAll('[data-detail-tab]'));
    const currentIndex = tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let nextIndex = null;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    if (nextIndex === null) return;

    event.preventDefault();
    const nextTab = tabs[nextIndex];
    activateTab(container, nextTab);
    nextTab.focus();
  };

  const toggleAccordion = (trigger) => {
    const block = trigger.closest('.spec-block');
    const content = block?.querySelector('[data-accordion-content]');
    if (!block || !content) return;

    const isOpen = block.classList.contains('is-open');
    block.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', (!isOpen).toString());
    content.hidden = isOpen;
  };

  const init = (container) => {
    if (!container || container.dataset.tabsReady === 'true') return;
    container.dataset.tabsReady = 'true';

    const tabs = container.querySelectorAll('[data-detail-tab]');
    const accordionTriggers = container.querySelectorAll('[data-accordion-trigger]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(container, tab));
      tab.addEventListener('keydown', (event) => onTabKeydown(container, event));
    });

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => toggleAccordion(trigger));
    });
  };

  const initAll = (scope = document) => {
    const containers = scope.matches?.(sectionSelector) ? [scope] : Array.from(scope.querySelectorAll(sectionSelector));
    containers.forEach((container) => init(container));
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
}
